<ng-container>
  <app-ark-container
    [future]="dataObservable"
    [loadingTemplate]="loading"
    [successTemplate]="success"
    [failureTemplate]="failure"
    [errorTemplate]="error"
    (onSuccess)="onSuccess($event[0])"
    (onFailure)="onFailure($event[0])"
  >
  </app-ark-container>

  <ng-template #loading>
    <div></div>
    <!-- <ul nz-menu>
      <li
        *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6]"
        style="padding: 0px 15px 0px 15px"
      >
        <nz-skeleton
          [nzTitle]="true"
          [nzActive]="true"
          [nzParagraph]="false"
        ></nz-skeleton>
      </li>
    </ul> -->
  </ng-template>

  <ng-template #failure>
    <!-- <div class="error-container">
      <div class="error-msg">
        <va-icon name="faExclamationTriangle" class="info-icon"></va-icon>
        <span class="error-text">{{ errorMsg }}</span>
      </div>
    </div> -->
  </ng-template>

  <ng-template #error>
    <!-- <div class="error-container">
      <div class="error-msg">
        <va-icon name="faExclamationTriangle" class="info-icon"></va-icon>
        <span class="error-text">{{ errorMsg }}</span>
        <a [href]="legacyUrl + '/entitlements'" *ngIf="viewEntitlements">
          here</a
        >
      </div>
    </div> -->
  </ng-template>

  <ng-template #success>
    <div class="research-container" *ngIf="showResearch">
      <div class="heading_part1 research header-2">
        <span style="float: left;">Research</span>
        <div
          *ngIf="showDedicatedPage"
          (click)="viewDedicatedResearch($event)"
          class="research-dedicated-btn"
          title=""
          role="button"
          tabindex="0"
        >
          <div id="researchViewer" class="tab-buttons">
            Launch Research Viewer
          </div>
        </div>
      </div>
      <ng-container *ngIf="loadingDocs">
        <ul nz-menu>
          <li
            *ngFor="let dummySection of [0, 1, 2, 3, 4, 5, 6]"
            style="padding: 0px 15px 0px 15px"
          >
            <nz-skeleton
              [nzTitle]="true"
              [nzActive]="true"
              [nzParagraph]="false"
            ></nz-skeleton>
          </li>
        </ul>
      </ng-container>
      <ng-container *ngIf="!loadingDocs">
        <div *ngIf="hasError" class="error-container">
          <div class="error-msg">
            <va-icon name="exclamation-triangle" class="info-icon"></va-icon>
            <span class="error-text">{{ errorMsg }}</span>
            <a [routerLink]="['/entitlements']" *ngIf="viewEntitlements">
              here</a
            >
          </div>
        </div>
        <div *ngIf="!hasError" class="fs2">
          <div
            class="research_holder"
            infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="50"
            (scrolled)="loadMoreItems()"
            [scrollWindow]="false"
          >
            <div class="fs2_holder">
              <table
                class="fs2_table inner"
                id="company-researcph"
                *ngIf="docs.length > 0"
              >
                <thead class="header_row">
                  <tr class="header_row">
                    <th class="submenu_part_subheader" style="width :20%">
                      <span>Broker</span>
                    </th>
                    <th class="submenu_part_subheader" style="width: 15%">
                      <span>Date Published</span>
                    </th>
                    <th class="submenu_part_subheader" style="width :40%">
                      <span>Title</span>
                    </th>
                    <th class="submenu_part_subheader" style="width: 15%">
                      <span>Analyst</span>
                    </th>

                    <th
                      class="submenu_part_subheader"
                      style="width: 10%;text-align: center;"
                    >
                      <span>Download</span>
                    </th>
                  </tr>
                </thead>
                <tbody class="infinite-scroll-container">
                  <tr *ngFor="let row of docs" class="show_border research_row">
                    <td class="provider">
                      <span
                        class="broker-span"
                        *ngIf="row.providerLink == ''"
                        >{{ row.providerName }}</span
                      >
                      <span class="broker-span" *ngIf="row.providerLink != ''"
                        ><a routerLink="{{ row.providerLink }}">{{
                          row.providerName
                        }}</a></span
                      >
                    </td>
                    <td class="date">
                      <span style="width: 44px;float: left">{{
                        row.publication_date | date: "dd-MMM "
                      }}</span
                      ><span>{{
                        row.publication_date | date: "'|' hh:mm a"
                      }}</span>
                    </td>
                    <td class="headline">
                      <div
                        nz-popover
                        [nzPopoverContent]="titleTemplate"
                        nzPopoverPlacement="bottom"
                        class="headline-wrapper"
                      >
                        <span
                          class="headline-span headline-link"
                          *ngIf="row.showInTab"
                          (click)="redirectToView($event, row)"
                          >{{ row.title }}</span
                        >
                        <span class="headline-span" *ngIf="!row.showInTab">{{
                          row.title
                        }}</span>
                      </div>
                      <ng-template #titleTemplate>
                        <p style="font-size: 12px;">{{ row.title }}</p>
                      </ng-template>
                    </td>
                    <td class="analysts">
                      <div
                        nz-popover
                        [nzPopoverContent]="analystTemplate"
                        nzPopoverPlacement="bottom"
                        class="headline-wrapper"
                      >
                        <span class="analysts-span">{{
                          row.primaryAnalyst
                        }}</span>
                      </div>
                      <ng-template #analystTemplate>
                        <p style="font-size: 12px;">{{ row.allAnalysts }}</p>
                      </ng-template>
                    </td>
                    <td class="download" style="text-align: center;">
                      <app-download-renderer
                        [dataValue]="row.dataValue"
                        [docId]="row.id"
                      >
                      </app-download-renderer>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-template>
</ng-container>
